import React from "react";
import { Line } from "react-chartjs-2";

const TrendChart = ({
  isStatsLoading,
  isExpanded,
  setIsExpanded,
  timeRange,
  setTimeRange,
  trendChartData,
  chartPlugins,
  trendChartOptions,
  chartRef,
}) => {
  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
        <h6 className="m-0 fw-bold text-primary">Statistik Traffic</h6>
        <div className="d-flex gap-2">
          <button
            className={`btn btn-sm ${
              isExpanded ? "btn-danger" : "btn-outline-secondary"
            }`}
            onClick={() => setIsExpanded(!isExpanded)}
            title={
              isExpanded
                ? "Kembali ke tampilan normal"
                : "Perlebar grafik untuk detail"
            }
          >
            <i
              className={`fa ${isExpanded ? "fa-compress" : "fa-expand"} me-1`}
            ></i>
            {isExpanded ? "Kecilkan" : "Perlebar"}
          </button>

          <div className="btn-group" role="group">
            <button
              className={`btn btn-sm ${
                timeRange === "daily" ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => setTimeRange("daily")}
            >
              Harian
            </button>
            <button
              className={`btn btn-sm ${
                timeRange === "weekly" ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => setTimeRange("weekly")}
            >
              Mingguan
            </button>
          </div>
        </div>
      </div>

      <div className="card-body">
        <div
          className={`${isExpanded ? "scrollable-container" : ""}`}
          style={isExpanded ? { maxHeight: "600px" } : {}}
        >
          {isStatsLoading ? (
            <div className="text-center py-5 text-muted">Memuat grafik...</div>
          ) : (
            <div
              style={{
                overflowX: "auto",
                overflowY: "hidden",
                width: "100%",
              }}
            >
              <div
                style={{
                  height: "300px",
                  width: isExpanded
                    ? `${Math.max(100, trendChartData.labels.length * 60)}px`
                    : "100%",
                  minWidth: isExpanded ? "1000px" : "0",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Line
                  ref={chartRef}
                  data={trendChartData}
                  options={trendChartOptions}
                  plugins={chartPlugins}
                />
              </div>
            </div>
          )}

          {isExpanded && (
            <div className="text-center text-muted small mt-2">
              <i className="fa fa-arrows-h me-1"></i> Geser ke samping untuk
              melihat seluruh tanggal
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrendChart;
